// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteUpsearchModel {
    static getAttributeTypeMap() {
        return SiteUpsearchModel.attributeTypeMap;
    }
}
SiteUpsearchModel.discriminator = undefined;
SiteUpsearchModel.additionalProperties = false;
SiteUpsearchModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<SiteSharedAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<SiteSharedContactUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<SiteSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<SiteSharedExternalIdUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<SiteSharedPhoneUpsearchModel>"
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<SiteSharedGlobalIdUpsearchModel>"
    },
    {
        "name": "siteRoleType",
        "baseName": "siteRoleType",
        "type": "RoleType"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "nickName",
        "baseName": "nickName",
        "type": "string"
    },
    {
        "name": "businessStartTime",
        "baseName": "businessStartTime",
        "type": "Date"
    },
    {
        "name": "businessEndTime",
        "baseName": "businessEndTime",
        "type": "Date"
    },
    {
        "name": "siteNote",
        "baseName": "siteNote",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "stateTaxId",
        "baseName": "stateTaxId",
        "type": "string"
    },
];
//# sourceMappingURL=siteUpsearchModel.js.map